<template>
  <div class="artBatchDialog" @click="onMaskClick">
    <div class="artBatchMain" @click="(e) => e.stopPropagation()">
      <div class="back" v-if="phase != 'running'">
        <PDFStatsButton :iconFont="`icon-icon_close`" customFontSize="14px" paddingTop="0 0" paddingH="0 0"
          @ButtonClick="onClose" />
      </div>
      <div class="dialogTitle">{{ mode == 'export' ? $t('art_batch_export_title') : $t('art_batch_import_title') }}</div>

      <!-- 阶段提示 -->
      <div class="phaseTip">
        <template v-if="phase == 'loading'">
          <i class="iconfont icon-icon_loading rotating" />
          <span>{{ mode == 'export' ? $t('art_batch_loading_list') : $t('art_batch_parsing') }}</span>
        </template>
        <template v-else-if="phase == 'preview'">
          <span>{{ $t('art_batch_preview_tip').replace('*', String(items.length)) }}</span>
          <span class="subTip" v-if="!hasIndex">{{ $t('art_batch_no_index_tip') }}</span>
        </template>
        <template v-else-if="phase == 'running'">
          <i class="iconfont icon-icon_loading rotating" />
          <span>{{ (mode == 'export' ? $t('art_batch_exporting') : $t('art_batch_importing'))
            .replace('*', String(doneCount)).replace('*', String(items.length)) }}</span>
          <span class="subTip" v-if="isSelectedExport">{{ $t('art_batch_export_selected_tip').replace('*', String(selected.length)) }}</span>
        </template>
        <template v-else-if="phase == 'done'">
          <span>{{ $t('art_batch_summary').replace('*', String(summary.success + summary.warning)).replace('*', String(summary.failed)) }}</span>
          <span class="subTip" v-if="isSelectedExport">{{ $t('art_batch_export_selected_tip').replace('*', String(selected.length)) }}</span>
          <span class="subTip" v-if="mode == 'export' && summary.success + summary.warning > 0">{{ $t('art_batch_export_saved') }}</span>
        </template>
        <template v-else-if="phase == 'error'">
          <i class="iconfont icon-icon_error" style="color: #E14C25;" />
          <span>{{ reasonText(fatalReason) }}</span>
        </template>
      </div>

      <!-- 进度条 -->
      <div class="progressBar" v-if="phase == 'running' || phase == 'done'">
        <div class="progressInner" :style="{ width: progressPercent + '%' }" />
      </div>

      <!-- 列表 -->
      <div class="batchTable" v-if="items.length > 0">
        <div class="batchHeader">
          <div class="colIndex">{{ $t('art_entry_header_title1') }}</div>
          <div class="colName">{{ $t('art_table_title1') }}</div>
          <div class="colCount">{{ $t('art_table_title2') }}</div>
          <div class="colStatus">{{ $t('art_batch_col_status') }}</div>
        </div>
        <div class="batchBody">
          <div class="batchRow" v-for="(item, index) in items" :key="index" :class="`status-${item.status}`">
            <div class="colIndex">{{ index + 1 }}</div>
            <div class="colName" :title="item.name">{{ item.name || '-' }}</div>
            <div class="colCount">{{ item.count }}</div>
            <div class="colStatus">
              <i v-if="item.status == 'running'" class="iconfont icon-icon_loading rotating" />
              <i v-else-if="item.status == 'success'" class="iconfont icon-icon_check_n ok" />
              <i v-else-if="item.status == 'warning'" class="iconfont icon-icon_question warn" />
              <i v-else-if="item.status == 'failed'" class="iconfont icon-icon_error fail" />
              <span class="statusText">{{ statusText(item) }}</span>
              <span class="noteText" v-if="noteText(item)">{{ noteText(item) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 按钮 -->
      <div class="bottom">
        <template v-if="phase == 'preview'">
          <PDFStatsButton :title="$t(`cancel`)" :color="`#ffffff`" :textColor="'#2690E1'" customFontSize="14px"
            paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0" @ButtonClick="onClose" />
          <div style="width: 20px" />
          <PDFStatsButton :title="$t(`art_batch_start_import`)" :color="`#2590E1`" textColor="white"
            :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"
            :isDisable="pendingCount == 0" @ButtonClick="startImport" />
        </template>
        <template v-else-if="phase == 'running'">
          <PDFStatsButton :title="$t(`art_batch_stop`)" :color="`#ffffff`" :textColor="'#2690E1'" customFontSize="14px"
            paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0" @ButtonClick="onCancelRun" />
        </template>
        <template v-else-if="phase == 'done'">
          <PDFStatsButton v-if="mode == 'import' && retryableCount > 0" :title="$t(`art_batch_retry_failed`)"
            :color="`#ffffff`" :textColor="'#2690E1'" customFontSize="14px" paddingTop="0 0"
            :borderStyle="'#2690E1 solid 1px'" paddingH="0 0" @ButtonClick="retryFailed" />
          <PDFStatsButton v-if="mode == 'export' && summary.success + summary.warning > 0"
            :title="$t(`art_batch_download_again`)" :color="`#ffffff`" :textColor="'#2690E1'" customFontSize="14px"
            paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0" @ButtonClick="download" />
          <div style="width: 20px" />
          <PDFStatsButton :title="$t(`confirm`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'"
            customFontSize="14px" paddingTop="0 0" paddingH="0 0" @ButtonClick="onFinish" />
        </template>
        <template v-else-if="phase == 'error'">
          <PDFStatsButton :title="$t(`confirm`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'"
            customFontSize="14px" paddingTop="0 0" paddingH="0 0" @ButtonClick="onClose" />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, shallowRef, computed, onMounted, onUnmounted } from 'vue'
import Toast from '~/utils/toast'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import PDFStatsButton from '@/components/Button/PDFStatsButton.vue'
import useUserStore from '@/store/modules/user'
import {
  runExport, runImport, parseWorkbook, buildWorkbook, downloadWorkbook, exportFileName, summarize, isRetryable, ERROR_I18N
} from '@/composables/useGlossaryBatch'
import type { BatchItem } from '@/composables/useGlossaryBatch'

type Phase = 'loading' | 'preview' | 'running' | 'done' | 'error'

const props = defineProps({
  mode: {
    type: String as () => 'export' | 'import',
    required: true
  },
  file: {
    type: Object as () => File | null,
    default: null
  },
  /** 导出时的勾选项（列表页跨页勾选），为空则导出全部 */
  selected: {
    type: Array as () => { id: number; termName?: string }[],
    default: () => []
  }
})

const emit = defineEmits(['onClose', 'onConfirm'])

const { t, te } = useI18n()
const userStore = useUserStore()
const { userRights } = storeToRefs(userStore)

const phase = ref<Phase>('loading')
// shallowRef：items 里的 entries 可能有几十万条，不能进深层响应式；刷新靠 refreshProgress 整体替换数组
const items = shallowRef<BatchItem[]>([])
// 组件已卸载（用户关闭弹窗），未完成的异步流程不得再改状态或触发下载
const disposed = ref(false)
const hasIndex = ref(true)
const fatalReason = ref('')
const cancelled = ref(false)
const doneCount = ref(0)

const summary = computed(() => summarize(items.value))
const isSelectedExport = computed(() => props.mode === 'export' && props.selected.length > 0)
const pendingCount = computed(() => items.value.filter((i) => i.status === 'pending').length)
const retryableCount = computed(() => items.value.filter(isRetryable).length)
const progressPercent = computed(() => {
  if (items.value.length === 0) return 0
  return Math.round((doneCount.value / items.value.length) * 100)
})

function reasonText(reason?: string): string {
  if (!reason) return ''
  // te 只查当前语言的词条；新 key 只在 zh/en 里，其他语言靠 fallbackLocale=en
  return te(reason) || te(reason, 'en') ? t(reason) : reason
}

function statusText(item: BatchItem): string {
  if (item.status === 'pending') return t('art_batch_status_pending')
  if (item.status === 'running') return t('art_batch_status_running')
  if (item.status === 'success') return t('art_batch_status_success')
  if (item.status === 'warning') {
    if (item.reason === 'art_batch_warn_count_mismatch') {
      return t('art_batch_warn_count_mismatch')
        .replace('*', String(item.expectedCount ?? '-'))
        .replace('*', String(item.count))
    }
    return reasonText(item.reason)
  }
  return reasonText(item.reason)
}

/** 解析阶段的附注：去重、空行、截断 */
function noteText(item: BatchItem): string {
  const parts: string[] = []
  if (item.skippedDuplicate) parts.push(t('art_batch_note_dup').replace('*', String(item.skippedDuplicate)))
  if (item.skippedEmpty) parts.push(t('art_batch_note_empty').replace('*', String(item.skippedEmpty)))
  if (item.truncated) parts.push(t('art_batch_note_truncated').replace('*', String(item.truncated)))
  if (item.nameTruncated) parts.push(t('art_batch_note_name_truncated'))
  return parts.join(' / ')
}

function refreshProgress() {
  if (disposed.value) return
  doneCount.value = items.value.filter((i) => i.status !== 'pending' && i.status !== 'running').length
  // shallowRef 只认数组引用；元素是原地修改的，整体替换一次触发重渲染
  items.value = [...items.value]
}

// ---------------- 导出 ----------------

async function startExport() {
  phase.value = 'loading'
  try {
    const result = await runExport({
      selected: props.selected,
      onListReady: (list) => {
        items.value = list
        phase.value = 'running'
        refreshProgress()
      },
      onProgress: () => refreshProgress(),
      isCancelled: () => cancelled.value,
    })
    if (disposed.value) return
    items.value = result
    refreshProgress()
    phase.value = 'done'
    // 用户点了"停止"：报告里已把未完成的库标为"已取消"，不自动下载残缺文件，留"重新下载"由用户决定
    if (!cancelled.value && summary.value.success + summary.value.warning > 0) {
      download()
    }
  } catch (e: any) {
    if (disposed.value) return
    fatalReason.value = ERROR_I18N[e?.code] || e?.message || 'art_batch_err_unknown'
    phase.value = 'error'
  }
}

function download() {
  const exportable = items.value.filter((i) => i.status === 'success' || i.status === 'warning')
  if (exportable.length === 0) return
  try {
    const wb = buildWorkbook(exportable, {
      indexSheet: t('art_batch_sheet_index'),
      colIndex: t('art_entry_header_title1'),
      colName: t('art_table_title1'),
      colCount: t('art_table_title2'),
      colSheet: 'Sheet',
      colSource: t('art_entry_header_title2'),
      colTarget: t('art_entry_header_title3'),
    })
    downloadWorkbook(wb, exportFileName(t('art_batch_file_prefix')))
  } catch (e) {
    console.error('glossary batch download failed', e)
    Toast(t('art_batch_err_download'))
  }
}

// ---------------- 导入 ----------------

async function prepareImport() {
  phase.value = 'loading'
  if (!props.file) {
    fatalReason.value = 'art_batch_err_no_file'
    phase.value = 'error'
    return
  }
  try {
    const parsed = await parseWorkbook(props.file)
    items.value = parsed.items
    hasIndex.value = parsed.hasIndex
    if (items.value.length === 0) {
      fatalReason.value = 'art_batch_err_empty_file'
      phase.value = 'error'
      return
    }
    phase.value = 'preview'
  } catch (e: any) {
    fatalReason.value = 'art_batch_err_parse'
    phase.value = 'error'
  }
}

async function startImport() {
  if (pendingCount.value === 0) return
  cancelled.value = false
  phase.value = 'running'
  refreshProgress()
  await runImport(items.value, {
    singleLimit: userRights.value?.termSingleTbSize || null,
    onProgress: () => refreshProgress(),
    isCancelled: () => cancelled.value,
  })
  if (disposed.value) return
  refreshProgress()
  phase.value = 'done'
}

// 只重试有可能成功的项：解析失败、登录失效的不重试
function retryFailed() {
  items.value.forEach((i) => {
    if (isRetryable(i)) {
      i.status = 'pending'
      i.reason = undefined
      i.reasonCode = undefined
    }
  })
  startImport()
}

// ---------------- 通用 ----------------

function onCancelRun() {
  cancelled.value = true
}

function onMaskClick() {
  // 运行中不允许点遮罩关闭，避免误操作
  if (phase.value === 'running') return
  onClose()
}

// 关闭时也要告诉父组件是否有已导入成功的库，父组件据此刷新列表
function hasChange(): boolean {
  return props.mode === 'import' && summary.value.success > 0
}

function onClose() {
  cancelled.value = true
  emit('onClose', hasChange())
}

function onFinish() {
  emit('onConfirm', hasChange())
}

onUnmounted(() => {
  disposed.value = true
  cancelled.value = true
})

onMounted(() => {
  if (props.mode === 'export') {
    startExport()
  } else {
    prepareImport()
  }
})
</script>

<style scoped lang="scss">
@keyframes batchRotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.rotating {
  display: inline-block;
  animation: batchRotate 1s linear infinite;
  color: #2590E1;
}

.artBatchDialog {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;

  .artBatchMain {
    display: flex;
    width: 640px;
    max-width: 94vw;
    max-height: 86vh;
    background-color: white;
    border-radius: 8px;
    flex-direction: column;
    position: relative;
    align-items: center;
    padding: 0 20px;

    .back {
      align-self: flex-end;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 20px;
    }
    .dialogTitle {
      margin-top: 40px;
      font-size: 16px;
      font-weight: bold;
      color: var(--text-color);
    }
    .phaseTip {
      margin-top: 16px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      color: var(--text-color);
      .iconfont { font-size: 16px; margin-right: 6px; }
      .subTip { font-size: 12px; color: #8C8C8C; }
    }
    .progressBar {
      width: 100%;
      height: 6px;
      background: #EAF5FC;
      border-radius: 3px;
      margin-top: 12px;
      overflow: hidden;
      .progressInner {
        height: 100%;
        background: #2590E1;
        transition: width 0.2s;
      }
    }
    .batchTable {
      width: 100%;
      margin-top: 12px;
      border: 1px solid #BFBFBF;
      display: flex;
      flex-direction: column;
      min-height: 120px;
      max-height: 46vh;
      .batchHeader, .batchRow {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 12px;
        padding: 0 10px;
        .colIndex { width: 40px; flex-shrink: 0; }
        .colName { flex: 1.4; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 8px; }
        .colCount { width: 60px; flex-shrink: 0; }
        .colStatus { flex: 1.6; min-width: 0; display: flex; flex-direction: row; align-items: center; flex-wrap: wrap; gap: 4px; }
      }
      .batchHeader {
        height: 36px;
        background-color: #EAF5FC;
        border-bottom: 1px solid #BFBFBF;
        color: var(--text-color1);
        flex-shrink: 0;
      }
      .batchBody {
        overflow-y: auto;
        flex: 1;
        .batchRow {
          min-height: 36px;
          padding-top: 6px;
          padding-bottom: 6px;
          border-bottom: 1px solid #F0F0F0;
          color: var(--text-color);
          .iconfont { font-size: 14px; }
          .ok { color: #52C41A; }
          .warn { color: #FAAD14; }
          .fail { color: #E14C25; }
          .statusText { word-break: break-all; }
          .noteText { font-size: 11px; color: #8C8C8C; width: 100%; }
        }
        .status-failed .statusText { color: #E14C25; }
        .status-warning .statusText { color: #B37700; }
        .status-pending .statusText { color: #8C8C8C; }
      }
    }
    .bottom {
      display: flex;
      margin-top: 20px;
      margin-bottom: 24px;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 40px;
      width: 100%;
      flex-shrink: 0;
    }
  }
}
</style>
